import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormService } from '../../services/form.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {

  showHeader: boolean;
  headerTitle: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService) { }

  @Input()
  set title(value: string) {
    this.headerTitle = value;
  }

  ngOnInit() {
    const that = this;
    const frame: number = +that.route.snapshot.paramMap.get('frame');
    that.showHeader = (frame === 0);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/header/header.component.ts